import React, { Component } from "react";
import { object, string, number, func, bool } from "prop-types";
import moment from "moment";
import "./TimesheetEntry.css";

class LeaveEntry extends Component {
  static propTypes = {
    entries: object,
    startDate: string,
    endDate: string,
    leave_type_id: number,
    changeHandler: func,
    focusHandler: func,
    leave_type: string,
    donor: string,
    readOnly: bool
  }

  constructor(props) {
    super(props);

    this.state = {
      entries: [],
      startDate: null,
      endDate: null
    }
  }

  render() {
    //create empty array of the week and assign related working hours from array if exist, otherwise 0:
    const tds = [...Array(7)].map((_, i) => {
      const keys = Object.keys(this.props.entries).filter(d => {

        let weekday = new Date(d).getDay() - 1;
        let day = moment(d);
        if (weekday === -1) weekday = 6;

        // weekday must be equal to i & day must be between start and end dates
        // [] at the end indicates that startDate & endDate are included in the interval
        return (weekday === i) && day.isBetween(this.props.startDate, this.props.endDate, null, []);
      });

      let day = new Date(this.props.startDate);
      day.setDate(day.getDate() + i);
      day = day.toISOString().substring(0, 10);

      const hours = keys.length > 0 ? this.props.entries[keys[0]] : 0;

      const args = { leave_type_id: this.props.leave_type_id, day: day };
      if (this.props.readOnly) {
        return (
          <td title={day} key={i} className="timesheetEntryDataWD">{hours}</td>
        );
      } else {
        return (
          <td title={day} key={i} className="timesheetEntryDataWD">
            <input type="text" value={hours}
              onChange={(e) => this.props.changeHandler(e, args)}
              onFocus={(e) => this.props.focusHandler(e)}
            />
          </td>
        );
      }
    });

    return (
      <tr className="timesheetEntryData">
        <td>{this.props.leave_type}</td>
        <td>{this.props.donor}</td>
        {tds}
      </tr>
    );
  }
}

export default LeaveEntry;


// WEBPACK FOOTER //
// ./src/components/main/timesheet/_common/LeaveEntry.js